export default {
  DAY: "day",
  WEEK: "week",
  STAGE: "stage",
};
